import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, InputNumber, Button, Space, message, Divider } from 'antd';
import { PlusOutlined, CloseOutlined } from '@ant-design/icons';
import axios from 'axios';
import "../milestone.css"

const BASE_URL = process.env.REACT_APP_CSC_API_BASE_URL


const MilestoneModal = ({ open, onClose, editMode, initialData }) => {
  const [form] = Form.useForm();
  const [fields, setFields] = useState([{ Title: '', ThresholdTransaction: 0, Reward: 0 }]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (editMode && initialData.length) {
      setFields(initialData);
      form.setFieldsValue({ milestones: initialData });
    } else {
      setFields([{ Title: '', ThresholdTransaction: 0, Reward: 0 }]);
      form.setFieldsValue({ milestones: [{ Title: '', ThresholdTransaction: 0, Reward: 0 }] });
    }
  }, [open, editMode, initialData, form]);

  const addField = () => {
    const newFields = [...fields, { Title: '', ThresholdTransaction: 0, Reward: 0 }];
    setFields(newFields);
    form.setFieldsValue({ milestones: newFields });
  };

  const removeField = idx => {
    const newFields = fields.filter((_, i) => i !== idx);
    setFields(newFields);
    form.setFieldsValue({ milestones: newFields });
  };

  const handleChange = (idx, key, value) => {
    const newFields = [...fields];
    newFields[idx][key] = value;
    setFields(newFields);
    form.setFieldsValue({ milestones: newFields });
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setSaving(true);
      await axios.post(`${BASE_URL}streak/milestones`, {
        milestones: values.milestones,
      });
      message.success('Milestones saved!');
      setSaving(false);
      onClose(true);
    } catch (err) {
      setSaving(false);
      if (err.response) {
        message.error(err.response.data?.message || 'Failed to save milestones');
      } else {
        message.error('Please fill all fields');
      }
    }
  };

  return (
    <Modal
      open={open}
      title={editMode ? 'Edit Milestones' : 'Add Milestone'}
      onCancel={() => onClose(false)}
      onOk={handleSubmit}
      width={650}
      okText="Save"
      confirmLoading={saving}
      className="milestone-modal"
    >
      <Form form={form} layout="vertical">
        {fields.map((field, idx) => (
          <div key={idx} className="milestone-form-row">
            <Space align="start" style={{ width: '100%' }}>
              <Form.Item
                label="Title"
                name={['milestones', idx, 'Title']}
                rules={[{ required: true, message: 'Title required' }]}
                style={{ flex: 1, minWidth: 120 }}
              >
                <Input
                  value={field.Title}
                  onChange={e => handleChange(idx, 'Title', e.target.value)}
                  placeholder="Title"
                  maxLength={30}
                />
              </Form.Item>
              <Form.Item
                label="Threshold"
                name={['milestones', idx, 'ThresholdTransaction']}
                rules={[{ required: true, message: 'Threshold required' }]}
                style={{ flex: 1, minWidth: 120 }}
              >
                <InputNumber
                  value={field.ThresholdTransaction}
                  onChange={val => handleChange(idx, 'ThresholdTransaction', val)}
                  placeholder="Threshold"
                  min={1}
                  style={{ width: '100%' }}
                />
              </Form.Item>
              <Form.Item
                label="Reward"
                name={['milestones', idx, 'Reward']}
                rules={[{ required: true, message: 'Reward required' }]}
                style={{ flex: 1, minWidth: 120 }}
              >
                <InputNumber
                  value={field.Reward}
                  onChange={val => handleChange(idx, 'Reward', val)}
                  placeholder="Reward"
                  min={1}
                  style={{ width: '100%' }}
                />
              </Form.Item>
              <Button
                icon={<PlusOutlined />}
                type="dashed"
                onClick={addField}
                style={{ marginTop: 30 }}
                disabled={idx !== fields.length - 1}
                aria-label="Add milestone"
              />
              {fields.length > 1 && (
                <Button
                  icon={<CloseOutlined />}
                  type="text"
                  danger
                  onClick={() => removeField(idx)}
                  style={{ marginTop: 30 }}
                  aria-label="Remove milestone"
                />
              )}
            </Space>
            {idx < fields.length - 1 && <Divider style={{ margin: '12px 0' }} />}
          </div>
        ))}
      </Form>
    </Modal>
  );
};

export default MilestoneModal;